var permiConst= {
    addStore: 18, //新增门店
    addPro: 4, //新增商品
    editPro: 5, //修改商品
    delPro: 6, //删除商品
    addLabel: 1, //新增标签
    delLabel: 3, //删除标签
    labelUpgrade: 2, //标签固件升级
    addGw: 7, //新增网关
    editGw: 14, //修改网关
    delGw: 8, //删除网关
    gwUpgrade: 9, //网关固件升级
    viewDemo: 10, //查看模板
    addDemo: 11, //新增模板
    editDemo: 13, //修改模板
    delDemo: 12, //删除模板
    siXunInterface: 15, //思迅接口
    yinBaoInterface: 16, //银豹接口
    cloudPlatformInterface: 17 //云平台接口
}
var systemInfos={       //系统信息
    version: 'v1.3.0.0'   //系统版本号
}
export {permiConst, systemInfos}


// WEBPACK FOOTER //
// ./src/components/common/constVars.js